<template>
  <qtm-chip
    v-if="quote.is_winning_quote && !order.requiresAdjustments && !order.cancelled"
    color="interactive"
    text-color="white"
  >
    PO Issued
  </qtm-chip>
</template>

<script setup lang="ts">
import type { Order, Quote } from '@quotetome/materials-api'

export interface Props {
  order: Order
  quote: Quote
}
defineProps<Props>()
</script>
